import { BaseResourceModel } from '../../models/base-resource.model';

export class EnquadramentoFundo extends BaseResourceModel {
  constructor(
    public codigo?: number,
    public descricao?: string,
    public segmento?: string,
  ) {
    super();
  }
  static converteJson(json: any): EnquadramentoFundo {
    return Object.assign(new EnquadramentoFundo(), json);
  }
}